import { colors, fonts } from '@grupoboticario/flora-tokens/altoContraste/web/ds'

export const altoContraste = {
  colors,
  fonts,
}
